import {Grid} from "@mui/material";
import React from "react";
import PropTypes from "prop-types";
import {mapLayout} from "./FreeformUtils";

export default function GridContainer(props: { meta: any, data: any }) {

    let styles = {} as any

    if (props.meta.padding) {
        styles["padding"] = props.meta.padding
    }
    if (props.meta.margin) {
        styles["margin"] = props.meta.margin
    }

    return <Grid container
                 style={styles}
                 sx={props.meta.sx}
                 key={JSON.stringify(props.meta)}>
        {props.meta.fields?.map((f: any) => mapLayout(f, props.data ? props.data : null))}
    </Grid>
}


GridContainer.propTypes = {
    meta: PropTypes.any.isRequired,
    data: PropTypes.any
}